module.exports = __webpack_public_path__ + "img/C.51286029.png";